import { Flex } from 'antd';
import invariant from 'tiny-invariant';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useGetScanConfigData } from 'business/quality-control/pages/segment-history/mobile/components/hooks/data';
import Routes from 'config/routes';
import Card from 'ui/card';

import { Scanner } from './components/scanner';

export const SegmentHistoryScanPage = () => {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site');

  const { data: scanConfig, error } = useGetScanConfigData();
  if (!scanConfig || error) {
    return null;
  }

  const scanRedirectionLink = `${Routes.QualitySegmentHistory}?`;

  return (
    <Flex justify="center" align="center" style={{ padding: 14 }}>
      <Card>
        <Scanner scanConfig={scanConfig} redirectLink={scanRedirectionLink} />
      </Card>
    </Flex>
  );
};
